import React, { useMemo } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { fieldSizing } from '../../utils/utilities';
import { Typography } from '@mui/material';
import { SIZE } from '../../constants/field-size';

const Divider = ({
  size,
  label = ""
}) => {

  const fieldSize = useMemo(() =>
    fieldSizing(size)
    , [size])

  return (
    <Grid md={fieldSize.md} lg={fieldSize.lg} sx={{ mt: (size && size === SIZE.XXL) && 2  }} >  {/* if size is XXL, it considered as Sub Section , that's why mt is added.*/}
      <div dangerouslySetInnerHTML={{ __html: label }} />
    </Grid>

  );
}

export default Divider;